import React, { useEffect } from 'react';
import mainLogo from '../../assets/icons/Logo.svg';
import { Link, useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { useUser } from '../../contexts/userContext';
import MobileHeader from './MobileHeader';
import card from '../../assets/icons/card.svg';
import close from '../../assets/icons/close.svg';
import userIcon from '../../assets/icons/78-user.svg';
import '../../Styles/Header.scss';
import { useUserMenu } from '../../hooks/useUserMenu.hook';

const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const {
    state: { isLoggedIn, subscribed, isAdmin },
  } = useUser();
  const { authentication, initials, isMenuOpen, setIsMenuOpen, menuRef, signOutUser } = useUserMenu();

  const [width, setWidth] = React.useState(window.innerWidth);
  const breakpoint = 1020;

  useEffect(() => {
    
    const handleWindowResize = () => setWidth(window.innerWidth);
    window.addEventListener('resize', handleWindowResize);
    return () => window.removeEventListener('resize', handleWindowResize);
  }, []);

  return width < breakpoint ? (
    <MobileHeader />
  ) : (
    <div className={`header sticky`}>
      <div className="links__header">
        <Link to="/">
          <img src={mainLogo} alt="logo" className="logo__header" />
        </Link>
        <Link to="/download" className={location.pathname === '/download' ? 'colored-link' : ''}>
          Download
        </Link>
        <a href={process.env.REACT_APP_BLOG_URL}>Blog</a>
        <a href={process.env.REACT_APP_PODCAST_URL}>Podcast</a>
        <Link to="/about" className={location.pathname === '/about' ? 'colored-link' : ''}>
          About us
        </Link>
        {isLoggedIn && isAdmin && (
          <>
            <Link
              to="/reports-admin"
              className={location.pathname === '/reports-admin' ? 'colored-link' : ''}>
              Admin
            </Link>
            <Link
              to="/invites-admin"
              className={location.pathname === '/invites-admin' ? 'colored-link' : ''}>
              Invite
            </Link>
            <Link
              to="/admin/resellers"
              className={location.pathname === '/admin/resellers' ? 'colored-link' : ''}>
              Resellers
            </Link>
          </>
        )}
      </div>
      <div className="sign">
        {isLoggedIn ? (
          <div className="flex justify-center">
            <div>
              <div className="dropdown relative" ref={menuRef}>
                <button
                  className="
                      dropdown-toggle
                      header-circle
                    "
                  type="button"
                  id="dropdownMenuButton1d"
                  aria-expanded={isMenuOpen}
                  onClick={() => setIsMenuOpen((v) => !v)}>
                  {authentication.currentUser ? initials : ''}
                </button>
                <ul
                  className={`
                      dropdown-menu
                      min-w-max
                      absolute
                      right-0
                      bg-white
                      text-base
                      z-50
                      float-left
                      py-2
                      list-none
                      text-left
                      rounded-lg
                      shadow-lg
                      mt-1
                      m-0
                      bg-clip-padding
                      border-none
                      ${isMenuOpen ? '' : 'hidden'}
                    `}
                  aria-labelledby="dropdownMenuButton1d">
                  <li>
                    <div
                      className="
                          dropdown-item
                          py-2
                          px-4
                          block
                          w-full
                          whitespace-nowrap
                          bg-transparent
                        ">
                      <p className="logged_name">{authentication.currentUser?.displayName}</p>
                      <p className="logged_email logged_links">
                        {authentication.currentUser?.email}
                      </p>
                    </div>
                  </li>
                  <hr className="h-0 my-2 border border-solid border-t-0 border-gray-700 opacity-25" />
                  <li>
                    <button
                      className="
                          dropdown-item
                          py-2
                          px-4
                          block
                          w-full
                          whitespace-nowrap
                          bg-transparent
                          logged_links
                          text-left
                        "
                      type="button"
                      onClick={() => {
                        setIsMenuOpen(false);
                        navigate('/account');
                      }}>
                      <img src={userIcon} alt="" /> My account
                    </button>
                  </li>
                  {subscribed ? (
                    <li>
                      <button
                        className="
                              dropdown-item
                              py-2
                              px-4
                              block
                              w-full
                              whitespace-nowrap
                              bg-transparent
                              logged_links
                              text-left
                            "
                        type="button"
                        onClick={() => {
                          setIsMenuOpen(false);
                          navigate('/subscription');
                        }}>
                        <img src={card} alt="" /> Subscription and card
                      </button>
                    </li>
                  ) : null}
                  <li>
                    <button
                      className="
                          dropdown-item
                          py-2
                          px-4
                          block
                          w-full
                          whitespace-nowrap
                          bg-transparent
                          logged_links
                          logged_links-sign-out
                          text-left
                        "
                      type="button"
                      onClick={() => {
                        setIsMenuOpen(false);
                        signOutUser();
                        navigate('/');
                      }}>
                      <img src={close} alt="" /> Sign out
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        ) : (
          <>
            <Link to="/signin">Sign in</Link>
            {/* <Link to="/signup">
              <button className="sign-up-btn">Sign up</button>
            </Link> */}
          </>
        )}
      </div>
    </div>
  );
};

export default Header;
